var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('a-avatar',{staticClass:"avatar",attrs:{"src":_vm.src,"size":_vm.sizeResponsive},on:{"click":function($event){return _vm.$emit('onClick')}}}):_c('DefaultIconLetter',{staticClass:"avatar",attrs:{"names":_vm.names,"size":_vm.sizeResponsive},on:{"click":function($event){return _vm.$emit('onClick')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }